/* eslint-disable @typescript-eslint/no-explicit-any */
interface ISaveObj<T = any> {
  value: T;
}

class Localstorage {
  private storage: Storage;

  constructor() {
    // 接管window.localstorage
    this.storage = window.localStorage;
  }

  // 保存
  save(key: string, value: any = "") {
    const saveObj: ISaveObj = {
      value,
    };
    // 储存
    this.storage.setItem(key, JSON.stringify(saveObj));
  }

  // 获取
  get<T>(key: string): T | null {
    if (!key) {
      throw new Error("localstorage get key值为空");
    }
    const data = this.storage.getItem(key);
    // 数据不存在，直接返回
    if (data) {
      try {
        const dataValue: ISaveObj<T> = JSON.parse(data);
        return dataValue.value;
      } catch (err) {
        // do nothing
      }
    }
    return null;
  }

  // 移除
  remove(key: string) {
    if (!key) {
      throw new Error("localstorage remove key值为空");
    }
    this.storage.removeItem(key);
  }
}

export default new Localstorage();
